import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentStatus } from '@payer-admin-ui/api/src/invoices/models/PaymentStatus';
import { PaletteName } from '@payer-admin-ui/components-v2/src/layout/theme';
import { StatusChip } from '@payer-admin-ui/components-v2/src/labels/StatusChip';

export type OldPaymentStatusChipProps = {
  status: PaymentStatus | 'OVERDUE';
};

export const PAYMENT_STATUS_COLORS = {
  [PaymentStatus.UNPAID]: 'primary',
  [PaymentStatus.UNUSED]: 'primary',
  [PaymentStatus.RESERVED]: 'warning',
  [PaymentStatus.PARTIALLY_PAID]: 'warning',
  [PaymentStatus.PARTIALLY_USED]: 'warning',
  [PaymentStatus.PAID]: 'success',
  [PaymentStatus.USED]: 'success',
  OVERDUE: 'danger',
} as const satisfies Record<PaymentStatus | 'OVERDUE', PaletteName>;

const OldPaymentStatusChip = ({ status }: OldPaymentStatusChipProps) => {
  const { t } = useTranslation();
  return (
    <StatusChip text={t(`enums.paymentAndCreditUsageStatus.values.${status}`)} color={PAYMENT_STATUS_COLORS[status]} />
  );
};

export { OldPaymentStatusChip };
